import { EventEmitter } from 'events';
import dispatcher from '../dispatcher';
import constants from '../constants';

class OfficeTypeStore extends EventEmitter {
    constructor() {
        super()

        // Set default state
        this.officeTypes = [];
    }

    handleActions(action) {
        switch(action.type) {
            case constants.OFFICE_TYPE_TOGGLE: {
                this.toggleSelectedOfficeType(action.officeTypeId);
                break;
            }
        }
    }

    toggleSelectedOfficeType(officeTypeId) {
        const officeType = this.officeTypes.find(function(ot) {return ot.Id == officeTypeId});
        officeType.IsSelected = !officeType.IsSelected;

        this.emit('change');
    }

    // Function returns all officesTypes when none are selected
    getSelectedOfficesTypes(){
        const filteredOfficesTypes = this.officeTypes.filter(result => result.IsSelected == true);
        return filteredOfficesTypes.length > 0 ? filteredOfficesTypes : this.officeTypes;
    }

    populateOfficeTypes(officeTypes) {
        this.officeTypes = officeTypes;
        this.setOfficeTypes();
    }

    getOfficeTypes() {
        return this.officeTypes;
    }

    setOfficeTypes() {
        this.officeTypes = this.officeTypes.map((ot) => {
            ot.IsSelected = false;
            return ot;
        })
    }
}

const officeTypeStore = new OfficeTypeStore;
officeTypeStore.dispatchToken = dispatcher.register(officeTypeStore.handleActions.bind(officeTypeStore));

export default officeTypeStore;